import { Map, List, fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'
import { RESET_DATA } from 'reducers/myJobs/reducer'
import {
  RESET_DATA as RESET_DATA_MA,
  CLEAR_STORE,
} from 'reducers/monitorsAndAlerts/reducer'

// constants
export const LOCUS_FETCH_LIST = 'locus/FETCH_LIST'
export const LOCUS_FETCH_LIST_SUCCESS = 'locus/LOCUS_FETCH_LIST_SUCCESS'
export const LOCUS_FETCH_LIST_FAILURE = 'locus/LOCUS_FETCH_LIST_FAILURE'
export const LOCUS_FETCH_TABLE_DATA = 'locus/GET_TABLE_DATA'
export const LOCUS_SET_TABLE_DATA = 'locus/SET_TABLE_DATA'
export const LOCUS_FETCH_ITEM = 'locus/FETCH_ITEM'
export const LOCUS_FETCH_FORM_DATA = 'locus/FETCH_FORM_DATA'
export const LOCUS_CHANGE = 'locus/CHANGE'
export const LOCUS_DELETE = 'locus/DELETE'
export const LOCUS_DISPLAY_TABLE = 'locus/DISPLAY_TABLE'
export const LOCUS_DISPLAY_FORM = 'locus/DISPLAY_FORM'
export const LOCUS_LOAD_STATE_ON = 'locus/LOAD_STATE_ON'
export const LOCUS_LOAD_STATE_OFF = 'locus/LOAD_STATE_OFF'
export const LOCUS_CLEAR_STATE = 'locus/CLEAR_STATE'
export const LOCUS_CLEAR_STATE_LIST = 'locus/CLEAR_STATE_LIST'
export const LOCUS_CLEAR_STATE_FORM = 'locus/CLEAR_STATE_FORM'
export const LOCUS_REDIRECT = 'locus/REDIRECT'
export const LOCUS_FROM_SITE = 'locus/LOCUS_FROM_SITE'
export const LOCUS_FROM_SITE_SUCCESS = 'locus/LOCUS_FROM_SITE_SUCCESS'
export const LOCUS_FROM_SITE_FAILURE = 'locus/LOCUS_FROM_SITE_FAILURE'
export const FETCH_LOCUS_TREE = 'locus/FETCH_LOCUS_TREE'
export const SUCCESS_LOCUS_TREE = 'locus/SUCCESS_LOCUS_TREE'
export const FAILURE_LOCUS_TREE = 'locus/FAILURE_LOCUS_TREE'

// actions
export const locusFetchList = ActionHelper.createActionObj(LOCUS_FETCH_LIST)
export const locusFetchTableData = ActionHelper.createActionObj(
  LOCUS_FETCH_TABLE_DATA,
)
export const locusClearState = ActionHelper.createActionObj(LOCUS_CLEAR_STATE)
export const locusClearStateList = ActionHelper.createActionObj(
  LOCUS_CLEAR_STATE_LIST,
)
export const locusClearStateForm = ActionHelper.createActionObj(
  LOCUS_CLEAR_STATE_FORM,
)
export const locusFetchFormData = ActionHelper.createActionObj(
  LOCUS_FETCH_FORM_DATA,
)
export const locusChange = ActionHelper.createActionObj(LOCUS_CHANGE)
export const locusDelete = ActionHelper.createActionObj(LOCUS_DELETE)
export const locusFromSite = ActionHelper.createActionObj(LOCUS_FROM_SITE)
export const fetchLocusTree = ActionHelper.createActionObj(FETCH_LOCUS_TREE)

// state
const initialState = fromJS({
  loading: true,
  unitsLoading: false,
  listData: [],
  locusTree: {},
  tableData: {
    data: [],
    count: 0,
  },
  formData: {
    sites: [],
    locusGroups: [],
    locus: null,
  },
})
const loadStateOn = state => state.set('loading', true)
const loadStateOff = state => state.set('loading', false)

// reducers
const locus = handleActions(
  {
    [LOCUS_LOAD_STATE_OFF]: loadStateOff,
    [combineActions(
      LOCUS_DELETE,
      LOCUS_CHANGE,
      LOCUS_FETCH_FORM_DATA,
      LOCUS_FETCH_LIST,
      LOCUS_LOAD_STATE_ON,
    )]: loadStateOn,
    [combineActions(LOCUS_FETCH_LIST, FETCH_LOCUS_TREE)]: state =>
      state.set('unitsLoading', true),
    [LOCUS_SET_TABLE_DATA]: (state, action) =>
      state.set('tableData', Map(action.tableData)),
    [LOCUS_DISPLAY_TABLE]: (state, action) =>
      state.set('loading', false).set('listData', List(action.listData)),
    [LOCUS_DISPLAY_FORM]: (state, action) =>
      state.set('loading', false).set('formData', Map(action.formData)),
    [LOCUS_REDIRECT]: state => state.set('loading', true),
    [combineActions(LOCUS_CLEAR_STATE, RESET_STORE)]: () => initialState,
    [LOCUS_CLEAR_STATE_LIST]: state =>
      state.set('tableData', initialState.get('tableData')),
    [LOCUS_FROM_SITE_SUCCESS]: (state, action) =>
      state.set('listData', List(action.payload)),
    [LOCUS_CLEAR_STATE_FORM]: state =>
      state.set('formData', initialState.get('formData')),
    [LOCUS_FETCH_LIST_SUCCESS]: state => state.set('unitsLoading', false),
    [SUCCESS_LOCUS_TREE]: (state, action) =>
      state.set('unitsLoading', false).set('locusTree', Map(action.payload)),
    [FAILURE_LOCUS_TREE]: state =>
      state.set('locusTree', initialState.get('locusTree')),
    [combineActions(RESET_DATA, RESET_DATA_MA, CLEAR_STORE)]: state =>
      state.set('listData', List([])),
  },
  initialState,
)

export default locus
